export default {
  title_single: 'Essa atividade já existe. O que deseja fazer?',
  title_multiple: 'Essas atividades já existem. O que deseja fazer?',
  subtitle_multiple: 'todas as outras atividades já foram criadas',
  create: 'Criar mesmo assim',
  edit: 'Editar o que já existe'
}
